import RegisterForm from "@/components/forms/registerForm";

export default function Register() {
  return <RegisterForm />;
}
